import axios from '@/common/axios'

import { ISettings } from '@/contexts/Global/entities'
import { PlatformUser } from '../auth'

export async function getConfigs<T>(configId: string) {
  const res = await axios.get<ISettings>('/configs', {
    params: { config_id: configId }
  })

  return res.data
}

export async function getUsers(): Promise<PlatformUser[]> {
  try {
    const res = await axios.get('/get-users')

    return res.data
  } catch {
    return []
  }
}

export async function getReportRequest(pathname: string, presignedUrl: boolean = false) {
  try {
    
    const { data } = await axios.get('/temp-files', {
      params: {
        file_key: pathname,
        generate_presigned_url: presignedUrl
      }
    })

    return presignedUrl ? data : data.content.data
  } catch {
    return []
  }
}
